export function normalizeElementId(str) {
    const normalizedNameMatchResult = str
        .toLowerCase()
        .replace(/[^\w]/g, "")
        .match(/[a-zA-Z]\w*/);
    if (!normalizedNameMatchResult) {
        throw new Error(`Failed to create normalizeElementId for input "${str}"`);
    }
    return normalizedNameMatchResult[0];
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibm9ybWFsaXplRWxlbWVudElkLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3V0aWxzL25vcm1hbGl6ZUVsZW1lbnRJZC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxNQUFNLFVBQVUsa0JBQWtCLENBQUMsR0FBVztJQUM1QyxNQUFNLHlCQUF5QixHQUFHLEdBQUc7U0FDbEMsV0FBVyxFQUFFO1NBQ2IsT0FBTyxDQUFDLFFBQVEsRUFBRSxFQUFFLENBQUM7U0FDckIsS0FBSyxDQUFDLGFBQWEsQ0FBQyxDQUFDO0lBQ3hCLElBQUksQ0FBQyx5QkFBeUIsRUFBRTtRQUM5QixNQUFNLElBQUksS0FBSyxDQUFDLGtEQUFrRCxHQUFHLEdBQUcsQ0FBQyxDQUFDO0tBQzNFO0lBQ0QsT0FBTyx5QkFBeUIsQ0FBQyxDQUFDLENBQUMsQ0FBQztBQUN0QyxDQUFDIn0=